import projectConfig from '@/config/config';
const baseURL = projectConfig.baseURL;
const api = {
  // 获取司机信息
  getDriverInfo: baseURL + '/acw/api/factory/findFactoryByDriver',
  // 新增进厂登记
  addRegister: baseURL + '/acw/api/factory/addInOutFactory',
  // 新获取设备识别车牌号接口
  getNewCarNoByDevice: baseURL + '/api/register/getNewPlateNumberByDevice',
  // 获取收发货单位（仓库关联的商户）
  registerGetTenantName: baseURL + '/acw/api/wh/findRelCompany',
  // 获取进厂登记详情
  getH5RegisterInfo: baseURL + '/api/register/getH5RegisterInfo',
  // 修改进场登记
  registerChangeCarReg: baseURL + '/api/register/changeCarReg',
  // 获取基地配置
  getConfigByTerminalNo: baseURL + '/acw/api/wh/showConfigDetail',
  // 查询收发货单位(采购商供应商)
  pageMdWarehouseResource: baseURL + '/api/whResource/pageMdWarehouseResource',
  // 查询商品名称
  queryListExt: baseURL + '/api/mdGoods/v2/queryListExt',
  // 获取二级收发货单位
  getForwardNameReceiveName: baseURL + '/api/register/getForwardNameReceiveName',
  // 验证码发送
  registerSmsSend: baseURL + '/acw/api/driver/sendLoginSms',
  // 进入验证码验证(模拟登陆)
  registerMockLogin: baseURL + '/acw/api/driver/smsLogin',
  // 离场
  outFactory: baseURL + '/acw/api/factory/outFactory',
  // 进场信息
  findFactoryByDriver: baseURL + '/acw/api/factory/findFactoryByDriver',
  // 企业信息
  getCompanyDetail: baseURL + '/acw/api/company/detail',
  // 出入库保存
  tripartiteSaveCarRegister: baseURL + '/acw/api/xinZiFactory/addInOutFactory',
  // 查询进场登记
  findFactoryDriverByPhone: baseURL + '/acw/api/factory/findFactoryByDriver',
  // 品名下拉（远程搜索）
  goodsInfoLikeList: baseURL + '/acw/api/xinZiFactory/like/list',
  // 是否开启危废（控制商品选择是否展示）
  enableHazardousWaste: baseURL + '/acw/api/xinZiFactory/enableHazardousWaste'
};

export default api;
